import { defineStore } from "pinia";

const DEFAULT_REFRESH_INTERVAL = 30000;
const MIN_REFRESH_INTERVAL = 5000;

export const autoRefreshStore = defineStore({
  id: "autoRefresh",
  state: () => ({
    list: [],
    refreshInterval: DEFAULT_REFRESH_INTERVAL,
  }),
  actions: {
    setList(data) {
      this.list = data;
    },
    setRefreshInterval(ms) {
      const val = Number(ms);
      this.refreshInterval =
        !isNaN(val) && val >= MIN_REFRESH_INTERVAL
          ? val
          : DEFAULT_REFRESH_INTERVAL;
    },
    addItem(item) {
      this.list.push(item);
    },
    removeItem(type, targetId) {
      this.list = this.list.filter(
        (item) =>
          !(
            item.type === type &&
            ((!item.target_id && !targetId) || item.target_id === targetId)
          )
      );
    },
  },
  getters: {
    shouldAutoRefresh: (state) => {
      return (type, id) =>
        state.list.some(
          (item) =>
            item.type === type && (!item.target_id || item.target_id === id)
        );
    },
    findItem: (state) => {
      return (type, targetId) =>
        state.list.find(
          (item) =>
            item.type === type &&
            ((!item.target_id && !targetId) || item.target_id === targetId)
        );
    },
  },
});
